var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import t from '../../../../lib/translate';
import { simpleHash } from '../../../../lib/string';
import UserContainer from '../../../../reducers/authentication';
import styled from 'styled-components';
var StyledButton = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :hover {\n    cursor: pointer;\n  }\n  margin-right: 40px;\n"], ["\n  :hover {\n    cursor: pointer;\n  }\n  margin-right: 40px;\n"])));
var LaunchNotesButton = function () {
    var user = UserContainer.useContainer().user;
    if (!user) {
        return _jsx(_Fragment, {});
    }
    var token = 'public_bhKNzqYtqijaAkgBE4duOrMW';
    var project = 'pro_Fd3hCYI4mvyyk';
    var selector = 'launch-notes-button';
    var embed = "\n    <launchnotes-embed\n      token=\"".concat(token, "\"\n      project=\"").concat(project, "\"\n      categories='[\"notification-service\"]'\n      toggle-selector=\"#").concat(selector, "\"\n      heading=\"").concat(t('launch.notes.heading'), "\"\n      heading-color=\"#FFFFFF\"\n      subheading=\"").concat(t('launch.notes.subheading'), "\"\n      subheading-color=\"#FFFFFF\"\n      primary-color=\"#366ba0\"\n      widget-placement=\"auto\"\n      widget-offset-skidding=\"-150\"\n      widget-offset-distance=\"15\"\n      show-unread\n      anonymous-user-id=\"").concat(simpleHash(user === null || user === void 0 ? void 0 : user.username), "\"\n      unread-placement=\"right\"\n      unread-offset-skidding=\"0\"\n      unread-offset-distance=\"10\"\n      unread-background-color=\"#366ba0\"\n      unread-text-color=\"#ffffff\"\n    ></launchnotes-embed>\n  ");
    return (_jsxs(_Fragment, { children: [_jsx(StyledButton, __assign({ id: selector }, { children: t('launch.notes.button.title') })), _jsx("div", { dangerouslySetInnerHTML: { __html: embed } })] }));
};
export default LaunchNotesButton;
var templateObject_1;
